import { SET_NCNS_DETAILS, SET_NCNS_REQUESTS, SET_UKG_EMPLOYEES } from '../actions/ncns';

const initialState = {
  ncnsDetails: {},
  ukgEmployees: [],
  ncnsRequests: {
    currentPage: 1,
    pageSize: -1,
    results: [],
  },
};

const ncnsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_NCNS_DETAILS:
      return {
        ...state,
        ncnsDetails: action.payload,
      };
    case SET_UKG_EMPLOYEES:
      return {
        ...state,
        ukgEmployees: action.payload,
      };
    case SET_NCNS_REQUESTS:
      return {
        ...state,
        ncnsRequests: action.payload,
      };
    default:
      return state;
  }
};

export default ncnsReducer;
